import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import EntryScreen from "@/pages/EntryScreen";
import ClientView from "@/pages/ClientView";
import GestorView from "@/pages/GestorView";
import ManagerLink from "@/pages/ManagerLink";
import ErrorBoundary from "@/components/shared/ErrorBoundary";

// Guards /gestor: only managers/admins may render it. Non-managers are sent
// to /cliente (or / if not logged in). Avoids leaking the manager UI shell to
// regular customers — backend endpoints are already 403/401 protected.
function ManagerOnly({ children }) {
  const { isLoggedIn, profile, loading } = useAuth();
  // Wait for both the auth bootstrap AND the profile fetch (loading flips false
  // after getSession resolves but BEFORE fetchProfile finishes — without this
  // wait, valid managers get redirected to /cliente on first paint).
  if (loading || (isLoggedIn && !profile)) return null;
  if (!isLoggedIn) return <Navigate to="/" replace />;
  const role = profile?.role;
  if (role !== 'manager' && role !== 'admin') {
    return <Navigate to="/cliente" replace />;
  }
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<EntryScreen />} />
              <Route path="/credits" element={<EntryScreen initialMode="credits" />} />
              <Route path="/cliente" element={<ClientView />} />
              <Route path="/gestor" element={<ManagerOnly><GestorView /></ManagerOnly>} />
              <Route path="/m/:token" element={<ManagerLink />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AppProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
